import {
  AgentChecklistBlockConfigSchema,
  AgentProcedureBlockConfigSchema,
  InstructionChecklistBlockConfigSchema,
  InstructionProcedureBlockConfigSchema,
} from '@onefootprint/request-types/smart-block-schemas';
import type {
  AgentChecklistBlockConfig,
  AgentProcedureBlockConfig,
  InstructionChecklistBlockConfig,
  InstructionProcedureBlockConfig,
} from '@onefootprint/request-types/smart-blocks';
import Ajv, { type Schema } from 'ajv';

const ajv = new Ajv();

const createParser = <T>(schema: Schema) => {
  const validate = ajv.compile<T>(schema);
  return (raw: string): T | null => {
    try {
      const config: unknown = JSON.parse(raw);
      return validate(config) ? config : null;
    } catch {
      return null;
    }
  };
};

const parseChecklistConfig = createParser<AgentChecklistBlockConfig>(AgentChecklistBlockConfigSchema);
const parseProcedureConfig = createParser<AgentProcedureBlockConfig>(AgentProcedureBlockConfigSchema);
const parseInstructionChecklistConfig = createParser<InstructionChecklistBlockConfig>(
  InstructionChecklistBlockConfigSchema,
);
const parseInstructionProcedureConfig = createParser<InstructionProcedureBlockConfig>(
  InstructionProcedureBlockConfigSchema,
);

export type { AgentChecklistBlockConfig, AgentProcedureBlockConfig };
export { parseChecklistConfig, parseInstructionChecklistConfig, parseInstructionProcedureConfig, parseProcedureConfig };
